// extracted by mini-css-extract-plugin
var _1 = "ExtensionSearchBar-module__animateUploadProgressBarWidth--fMc9H";
var _2 = "ExtensionSearchBar-module__animatedBackground--Gblqe";
var _3 = "ExtensionSearchBar-module__clearButton--PbO2E";
var _4 = "ExtensionSearchBar-module__clearButtonContainer--TJh6j";
var _5 = "ExtensionSearchBar-module__container--Tzjxm";
var _6 = "ExtensionSearchBar-module__icon--CYaDw";
var _7 = "ExtensionSearchBar-module__stuck--iJLFZ";
export { _1 as "animateUploadProgressBarWidth", _2 as "animatedBackground", _3 as "clearButton", _4 as "clearButtonContainer", _5 as "container", _6 as "icon", _7 as "stuck" }
